import { render, staticRenderFns } from "./FundTransferTable.vue?vue&type=template&id=b7b09e66&"
import script from "./FundTransferTable.vue?vue&type=script&lang=js&"
export * from "./FundTransferTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports